import { Component, Input, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { DocumentContract } from '../../../_models/document-contract';
import { D4signAccountBalanceDTO } from '../../../_models/_dto/d4sign-account-balance.dto';
import { ContractDocumentService } from '../../../_services/contract-document.service';

@Component({
	selector: 'contracts-processing-signature',
	styles: [require('./contracts-processing-signature.component.css')],
	template: require('./contracts-processing-signature.component.html')
})

export class ContractsProcessingSignatureComponent implements OnInit {

	@Input() accountBalance: D4signAccountBalanceDTO;

	documentsProcessingSignature: DocumentContract[] = [];
	selectedDocuments: DocumentContract[] = [];

	constructor(
		public dialog: MdDialog,
		private contractDocumentService: ContractDocumentService
	) { }

	async ngOnInit() {
		this.findDocuments();
	}

	findDocuments(): void {
		this.contractDocumentService.getProcessingSignaturesDocuments()
			.subscribe((data) => {
				this.documentsProcessingSignature = data;
			}, (error) => console.log(error));
	}

	sendDocumentForSignature(document: DocumentContract) {
		this.contractDocumentService.sendProcessingSignaturesDocuments([document.id])
			.subscribe(() => {
				console.log('sucesso');
				this.findDocuments();
			}, (error) => console.log(error));
	}

	sendDocumentsSelectedForSignature() {
		const ids = this.selectedDocuments.map(document => document.id)
		this.contractDocumentService.sendProcessingSignaturesDocuments(ids)
			.subscribe(() => {
				console.log('sucesso');
				this.findDocuments();
			}, (error) => console.log(error));

	}

	isSelectable(document: DocumentContract): boolean {
		return this.accountBalance && this.selectedDocuments.length >= this.accountBalance.balanceSignatures && this.selectedDocuments.find(d => d === document) === undefined;
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/contracts-balance/contracts-processing-signature/contracts-processing-signature.component.ts